import type { DsdEditorReviewMode } from "./rail/rail-counts";
import { logUserAction, type UserActionFile } from "@/apis/logs/route";

/** 진입 경로: "홈" = 검토 결과 개요 화면, "툴바" = 상단 탭 버튼. */
type ReviewModeEntry = "홈" | "툴바";

/**
 * 사용자가 기업명 검토 화면에 새로 들어올 때만 행동 로그를 남긴다.
 * 이미 그 화면을 보고 있으면(개요가 아니고 같은 모드) 다시 눌러도 남기지 않는다.
 * 개요에서 돌아오는 경우는 모드가 그대로여도 새 진입이므로 남긴다.
 */
export const logCompanyNameReviewEntry = ({
  nextMode,
  currentMode,
  showOverview,
  entry,
  file,
}: {
  nextMode: DsdEditorReviewMode;
  currentMode: DsdEditorReviewMode;
  showOverview: boolean;
  entry: ReviewModeEntry;
  file: UserActionFile;
}) => {
  if (nextMode !== "company-name-review") return;
  const alreadyOpen = !showOverview && currentMode === nextMode;
  if (alreadyOpen) return;

  logUserAction(`DSD 리뷰, 기업명 검토 시작 (${entry})`, [file], {
    notify: false,
  });
};
